<div class="row">
  <div class="col-12">
    <div class="card p-3 mb-3">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="page-title">Purchased Spot Booking</h4>
        <button
          class="btn btn-primary ml-3"
          routerLink="/user/spot-booking/create"
        >
          + Create Booking
        </button>
      </div>
      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">User Name</th>
              <th scope="col">User Email</th>
              <th scope="col">Start Date</th>
              <th scope="col">End Date</th>
              <th scope="col">Price</th>
              <th scope="col">VAT Amount</th>
              <th scope="col">Status</th>
              <th scope="col">Create Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let booking of purchaseBookingsList">
              <td>{{ booking.user_id.username }}</td>
              <td>{{ booking.user_id.email }}</td>
              <td>{{ booking.startDate }}</td>
              <td>{{ booking.endDate }}</td>
              <td style="color: red; font-weight: bold">
                {{ booking.currency }}
                {{
                  booking.chargeableAmount
                    ? booking.chargeableAmount / 100
                    : "-"
                }}
              </td>
              <td>{{ booking.totalVatAmount }}</td>
              <td>
                <span
                  class="badge px-2"
                  [ngClass]="{
                    'badge-success':
                      booking.status === 'active' ||
                      booking.status === 'completed',
                    'badge-danger':
                      booking.status === 'cancelled' ||
                      booking.status === 'expired',
                    'badge-warning':
                      booking.status === 'pending' ||
                      booking.status === 'cancel_requested' ||
                      booking.status === 'refund_requested',
                    'badge-info': booking.status === 'refunded'
                  }"
                  style="
                    text-transform: capitalize;
                    font-size: 12px;
                    border-radius: 10px;
                  "
                >
                  {{ booking.status.split("_").join(" ") | titlecase }}
                </span>
              </td>
              <td>{{ booking.created_at | date : "short" }}</td>
              <td>
                <div class="d-flex flex-wrap gap-1">
                  <button
                    class="btn btn-sm btn-info mr-1 mb-1"
                    (click)="viewBookingDetails(booking._id)"
                    ngbTooltip="View Details"
                  >
                    <i class="fa fa-eye"></i>
                  </button>

                  <!-- <ng-container *ngIf="booking.status === 'active'">
                    <button
                      class="btn btn-sm btn-warning mr-1 mb-1"
                      (click)="cancelRequest(booking._id)"
                      ngbTooltip="Cancel Request"
                    >
                      <i class="fa fa-times-circle"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-success mr-1 mb-1"
                      (click)="completeBooking(booking._id)"
                      ngbTooltip="Complete Booking"
                    >
                      <i class="fa fa-check-circle"></i>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="booking.status === 'pending'">
                    <button
                      class="btn btn-sm btn-success mr-1 mb-1"
                      (click)="activeBooking(booking._id)"
                      ngbTooltip="Active Booking"
                    >
                      <i class="fa fa-play-circle"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-warning mr-1 mb-1"
                      (click)="cancelRequest(booking._id)"
                      ngbTooltip="Cancel Request"
                    >
                      <i class="fa fa-times-circle"></i>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="booking.status === 'cancelled'">
                    <button
                      class="btn btn-sm btn-primary mr-1 mb-1"
                      (click)="refundBooking(booking._id)"
                      ngbTooltip="Refund Booking"
                    >
                      <i class="fa fa-money"></i> Refund
                    </button>
                  </ng-container> -->
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="purchaseBookingsList.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalcount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Modals -->
<!-- Cancel Request Modal -->
<ng-template #cancelRequestModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Cancel Request</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to send a cancel request for this booking?</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.close('Close clicked')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-warning"
      (click)="confirmCancelRequest()"
    >
      Send Cancel Request
    </button>
  </div>
</ng-template>

<!-- Complete Booking Modal -->
<ng-template #completeBookingModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Complete Booking</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to mark this booking as completed?</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.close('Close clicked')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-success"
      (click)="confirmCompleteBooking()"
    >
      Complete Booking
    </button>
  </div>
</ng-template>

<!-- Refund Booking Modal -->
<ng-template #refundBookingModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Refund Booking</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to process refund for this booking?</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.close('Close clicked')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="confirmRefundBooking()"
    >
      Process Refund
    </button>
  </div>
</ng-template>

<ng-template #viewDetailsmodal let-modal>
  <div class="modal-header text-dark">
    <h4 class="modal-title">Booking Details</h4>
    <button
      type="button"
      class="btn-close btn-close-white"
      style="border: none; background: none"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <!-- Booking Details -->
      <div class="col-md-6 mb-4">
        <div class="card h-100 border-0 shadow-sm">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-calendar-alt me-2"></i> Booking Details
            </h5>
          </div>
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="fw-bold">Status:</span>
              <span
                class="badge px-2"
                [ngClass]="{
                  'badge-success':
                    details.status === 'active' ||
                    details.status === 'completed',
                  'badge-danger':
                    details.status === 'cancelled' ||
                    details.status === 'expired',
                  'badge-warning':
                    details.status === 'pending' ||
                    details.status === 'cancel_requested' ||
                    details.status === 'refund_requested',
                  'badge-info': details.status === 'refunded'
                }"
                style="
                  text-transform: capitalize;
                  font-size: 12px;
                  border-radius: 10px;
                "
              >
                {{ details.status.split("_").join(" ") | titlecase }}
              </span>
            </div>

            <div class="mb-2">
              <small class="text-muted">Start Date</small>
              <div class="d-flex align-items-center">
                <span>{{ details.startDate | date : "mediumDate" }}</span>
              </div>
            </div>

            <div class="mb-2">
              <small class="text-muted">End Date</small>
              <div class="d-flex align-items-center">
                <span>{{ details.endDate | date : "mediumDate" }}</span>
              </div>
            </div>

            <div class="mt-3">
              <small class="text-muted">Slots</small>
              <div class="d-flex flex-wrap gap-1 mt-1">
                <span
                  *ngFor="let slot of details.slots"
                  class="badge bg-light text-dark"
                >
                  {{ slot }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Payment Info -->
      <div class="col-md-6 mb-4">
        <div class="card h-100 border-0 shadow-sm">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-credit-card me-2"></i> Payment Information
            </h5>
          </div>
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="fw-bold">Amount:</span>
              <span class="fs-5 text-primary"
                >{{ details.currency }}
                {{ details.chargeableAmount / 100 | number : "1.2-2" }}</span
              >
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted">Without VAT:</span>
              <span
                >{{ details.currency }}
                {{ details.totalAmountWithoutVat | number : "1.2-2" }}</span
              >
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted"
                >VAT ({{ details.totalVatPercentage }}%):</span
              >
              <span
                >{{ details.currency }}
                {{ details.totalVatAmount | number : "1.2-2" }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Spot Info -->
      <div class="col-md-6 mb-4">
        <div class="card h-100 border-0 shadow-sm">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-map-marker-alt me-2"></i> Spot Information
            </h5>
          </div>
          <div class="card-body">
            <div class="mb-2">
              <small class="text-muted">Title</small>
              <p class="mb-1 fw-bold">{{ details.spotBookingId?.title }}</p>
            </div>

            <div class="mb-2">
              <small class="text-muted">Address</small>
              <p class="mb-1">{{ details.spotBookingId?.address }}</p>
            </div>

            <div class="mb-3">
              <small class="text-muted">Asset Type</small>
              <p class="mb-1">
                <span class="badge bg-primary text-white py-1 px-2">{{
                  details.spotBookingId?.assetType
                }}</span>
              </p>
            </div>

            <div *ngIf="details.spotBookingId?.beachImage" class="mt-3">
              <img
                [src]="details.spotBookingId.beachImage"
                alt="Spot Image"
                class="img-fluid rounded shadow-sm"
                style="max-height: 200px; width: 100%; object-fit: cover"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- User Info -->
      <div class="col-md-6 mb-4">
        <div class="card h-100 border-0 shadow-sm">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-user me-2"></i> User Information
            </h5>
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center mb-4">
              <div class="flex-grow-1 ms-3">
                <h6 class="mb-0">{{ details.user_id?.name }}</h6>
                <small class="text-muted">{{ details.user_id?.email }}</small>
              </div>
            </div>

            <div class="mb-2">
              <small class="text-muted">Email</small>
              <p class="mb-1">
                <i class="fas fa-envelope text-muted me-2"></i>
                {{ details.user_id?.email }}
              </p>
            </div>

            <div class="mb-2">
              <small class="text-muted">Country</small>
              <p class="mb-1">
                <i class="fas fa-globe text-muted me-2"></i>
                {{ details.user_id?.countryObject?.countryName }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.close('Close clicked')"
    >
      Close
    </button>
  </div>
</ng-template>
